import React from 'react';

interface AddActionCardProps {
  onClick: () => void;
}

const AddActionCard: React.FC<AddActionCardProps> = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="flex flex-col items-center justify-center rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow duration-300 border-2 border-dashed focus:outline-none focus:ring-2"
      style={{ 
        backgroundColor: 'var(--rhea-card-bg)',
        borderColor: 'var(--rhea-card-border)'
      }}
      aria-label="Add new action"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-12 w-12"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
        style={{ color: 'var(--rhea-text-secondary)' }}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
      </svg>
      <span 
        className="mt-2 font-medium"
        style={{ color: 'var(--rhea-text-secondary)' }}
      >
        Add Action
      </span>
    </button>
  );
};

export default AddActionCard; 